import Vue from 'vue';
import Vuex from 'vuex';
import { apiCalls } from '@/mixins/apiCalls.js';

//load modules
import session from './modules/session';
import series from './modules/series';
import sectionEditor from './modules/sectionEditor';
import ui from './modules/ui';
import events from './modules/events';
import reports from './modules/reports';
import datePicker from './modules/datePicker';

Vue.use(Vuex);

export default new Vuex.Store({
 mixins: [apiCalls],    
	state: {
		root: process.env.VUE_APP_ROOT,
		host: process.env.VUE_APP_BASE,
		loading: false,
		eventname: '',
		refSerie: 'Test'
	},
	getters: {},
	mutations: {},
	actions: {},
	modules: { session, series, sectionEditor, ui, events, reports, datePicker }
});
